export const languages = [
  { id: 1, lang: "en", name: "home.language.en", url: "/" },
  { id: 2, lang: "es", name: "home.language.es", url: "/es/" },
];

export const defaultLang = "en";

export const showDefaultLang = false;

export const ui = {
  en: {
    publicProfile: {
      button: { contact: "Contact", discover: "Discover" },
      events: {
        allActivity: "All Activity",
        button: {
          addToCalendar: "Add to Calendar",
          back: "Back to Events",
          visitEvent: "Visit Event",
        },
        details: {
          lineup: { title: "Lineup" },
          location: { title: "Location" },
          promoter: { title: "Promoter" },
          readLess: "Read less",
          readMore: "Read more",
          title: "About This Event",
        },
        dropdown: {
          filter: { past: "Past Events", upcoming: "Upcoming Events" },
        },
        emptyState: {
          subtitle:
            "There are no events to display. Try changing your search filter for different results.",
          title: "No events to show",
        },
      },
      gallery: { button: { download: "Download" } },
      networks: { title: "Social media" },
      overview: {
        bio: { readMore: "Read more", title: "Bio" },
        eventList: {
          title: { future: "Upcoming Events", past: "Past Events" },
        },
        eventSlider: {
          seeMore: "View all events",
          title: "Highlighted Events",
        },
        gallery: { seeMore: "See more", title: "Gallery" },
        onlinePresence: {
          exploreAll: "Explore all",
          subtitle: "Follow me",
          title: "Online Presence",
        },
        press: {
          button: { readMore: "Read more", viewAll: "View all articles" },
          details: {
            button: { return: "All press articles", visit: "Visit article" },
          },
          title: "Press Articles",
        },
        techRider: {
          information:
            "The image is for reference and may not be fully representative.",
          seeMore: "Explore details",
          title: "Tech Rider",
        },
        tracks: {
          seeMore: "See more",
          table: {
            album: "Album",
            duration: "Length",
            label: "Label",
            plays: "Plays",
            releaseDate: "Release date",
            title: "Title",
          },
          title: "Top Tracks",
        },
        videos: { seeMore: "See more", title: "Top Videos" },
      },
      player: {
        listenOn: {
          desktop: "Available on",
          mobile: "Continue listening on",
        },
      },
      tab: { events: "Events", gallery: "Gallery", overview: "Overview" },
    },
    privacy: {
      button: "Back to home page",
      changes: {
        description:
          "We reserve the right to update this privacy policy at any time. We will notify you of any changes by posting the new policy on our website.",
        titleBold: "6. Changes to the Privacy Policy:",
      },
      collection: {
        description:
          "We collect personal information that you provide to us directly, such as your name, email address, and phone number, when you register on our website, make a purchase, or contact us.",
        titleBold: "1. Information Collection:",
      },
      contact: {
        description:
          "If you have any questions about this privacy policy, you can contact us at privacy@mavelpoint.com",
        titleBold: "7. Contact:",
      },
      protection: {
        description:
          "We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.",
        titleBold: "3. Information Protection:",
      },
      rights: {
        description:
          "You have the right to access, rectify, and delete your personal data. You may also exercise other rights guaranteed by European and Spanish regulations. For more information, you can contact us at privacy@mavelpoint.com",
        titleBold: "5. User Rights:",
      },
      sharing: {
        bulletPoint1: "With your consent.",
        bulletPoint2: "To comply with legal obligations.",
        bulletPoint3: "To protect our rights and the safety of our users.",
        description:
          "We do not share your personal information with third parties, except in the following circumstances:",
        titleBold: "4. Information Sharing:",
      },
      subtitle:
        "At MavelPoint, we are committed to protecting the privacy of our users. This privacy policy describes how we collect, use, and protect your personal information.",
      title: "Privacy Policy",
      use: {
        bulletPoint1: "Provide and improve our services.",
        bulletPoint2: "Process your transactions and send you confirmations.",
        bulletPoint3: "Respond to your inquiries and provide customer support.",
        bulletPoint4:
          "Send you promotional and marketing communications, if you have consented to receive them.",
        description: "We use your personal information to:",
        titleBold: "2. Use of Information:",
      },
    },
    cookie: {
      changes: {
        description:
          "We reserve the right to update this cookie policy at any time. We will notify you of any changes by posting the new policy on our website.",
        titleBold: "5. Changes to the Cookie Policy:",
      },
      contact: {
        description:
          "If you have any questions about this cookie policy, you can contact us at privacy@mavelpoint.com",
        titleBold: "6. Contact:",
      },
      how: {
        bulletPoint1: "Remember your preferences and settings.",
        bulletPoint2:
          "Improve the functionality and performance of our website.",
        bulletPoint3: "Analyze traffic and user behavior on our site.",
        bulletPoint4: "Provide personalized content and advertising.",
        description: "We use cookies to:",
        titleBold: "2. How do we use cookies?",
      },
      managing: {
        description:
          "You can manage cookies through your browser settings. Most browsers allow you to refuse or accept cookies, as well as delete cookies already stored on your device. Please note that if you choose to block or delete cookies, some parts of our website may not function properly.",
        titleBold: "4. Managing cookies:",
      },
      subtitle:
        "At MavelPoint, we use cookies to enhance the experience of our users on our website. Below, we explain what cookies are, how we use them, and how you can manage them.",
      title: "Cookie Policy",
      types: {
        bulletPoint1:
          "Essential cookies: These cookies are necessary for the operation of the website and cannot be disabled in our systems. They are usually set in response to actions made by you, such as setting your privacy preferences, logging in, or filling out forms.",
        bulletPoint2:
          "Performance cookies: These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site.",
        bulletPoint3:
          "Functionality cookies: These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.",
        bulletPoint4:
          "Advertising cookies: These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant ads on other sites.",
        titleBold: "3. Types of cookies we use:",
      },
      what: {
        description:
          "Cookies are small text files that are stored on your device when you visit a website. These files allow the website to remember your actions and preferences (such as login, language, font size, and other display preferences) over a period of time, so you don’t have to re-enter them whenever you return to the site or browse from one page to another.",
        titleBold: "1. What are cookies?",
      },
    },
    home: {
      banner: {
        dreambeach: {
          description:
            "Join the MavelPoint UPNEXT contest and get your chance to perform on our 360 stage this summer in Spain.",
          title: "Want to perform at Dreambeach 2025?",
        },
      },
      benefitsSection: {
        firstCard: {
          description:
            "Link your social media, upload photos, set up your tech rider, promote your events and write your biography. We’ll handle the design.",
          listOne: "Easy to create",
          listThree: "All-in-one place",
          listTwo: "Automatically updated",
          subtitle: "A standout profile in just a few simple steps",
          title: "Create your press kit",
        },
        secondCard: {
          description:
            "Promoters, agencies, and other industry professionals will be able to find you, get interested in your content, and reach out to you to create professional opportunities.",
          listOne: "Expand your network",
          listThree: "Grow bookings",
          listTwo: "Get discovered",
          subtitle:
            "Easily connect with the people who can level up your career",
          title: "Boost your visibility",
        },
        thirdCard: {
          description:
            "Use our MavelTree link-in-bio tool to make your online presence easily accessible and boost engagement with a streamlined profile!",
          listOne: "Auto-generated",
          listThree: "Always up-to-date",
          listTwo: "All-in-one link",
          subtitle: "Say goodbye to manually updating your link",
          title: "Optimize your link in bio",
        },
        titleColor: "all-in-one platform",
        titleOne: "Join our",
        titleTwo: "to",
      },
      button: { createPressKit: "Create your MavelPoint" },
      callToAction: {
        button: "Join",
        buttonSuccess: "Joined!",
        error: {
          "500":
            "We couldn't add you to the waiting list. Please try again later.",
          invalidEmail:
            "Invalid email. Please check the format (e.g., name@example.com)",
        },
        input: { placeHolder: "Enter your email" },
        success:
          "You are already on our waiting list. We will contact you soon.",
      },
      footer: {
        cookie: "Cookie Policy",
        privacy: "Privacy Policy",
        rights: "© MavelPoint 2025, All Rights Reserved.",
        terms: "Terms and Conditions",
      },
      headerSection: {
        description:
          "Looking for a space to showcase who you are as an artist? MavelPoint connects with your social networks and streaming services to boost your visibility.",
        title: "Your press kit is now your",
        titleColor: "MavelPoint",
      },
      industryConnectionSection: {
        cardBooking: {
          badge: { comingSoon: "Coming Soon", title: "Booking Agencies" },
          subtitle:
            "Manage presentation dates, tours, and events with ease, avoiding conflicts and optimizing your artists' availability.",
          title: "Professional Roster Management",
        },
        cardLabels: {
          badge: { comingSoon: "Coming Soon", title: "Labels" },
          subtitle:
            "Pre-filter tracks, view progress, and access artist information in a centralized way.",
          title: "Optimized Track Management",
        },
        cardPress: {
          badge: { comingSoon: "Coming Soon", title: "Press & Media" },
          subtitle: "Assign team members for the coverage of each event.",
          title: "Streamlined Event Coverage",
        },
        cardPromoters: {
          badge: { comingSoon: "Coming Soon", title: "Promoters" },
          subtitle:
            "Easily send requests, discover new artists, and make data-driven decisions.",
          title: "Efficient Event Management",
        },
        iconSpan: "Artist",
        subtitle:
          "Gain visibility with key players and attract opportunities for professional growth.",
        title: "with the industry",
        titleColor: "Connect",
      },
      language: { en: "English", es: "Spanish" },
      marqueeSection: { manager: "Manager" },
      navBar: { button: "Get Started", buttonSecondary: "View Demo" },
      role: { dj: "Dj", producer: "Producer" },
      socialMediaSection: {
        listOne: "Profile updates instantly",
        listOneBold: "Auto-sync:",
        listThree: "Share your posts",
        listThreeBold: "Boost engagement:",
        listTwo: "Link to your selling platforms",
        listTwoBold: "Drive sales:",
        subtitle:
          "Keep your profile automatically up to date; showcase your posts, videos, and tracks.",
        title: "your social media",
        titleColor: "Plug in",
      },
    },
  },
  es: {
    publicProfile: {
      button: { contact: "Contactar", discover: "Descubrir" },
      events: {
        allActivity: "Toda la actividad",
        button: {
          addToCalendar: "Agregar al calendario",
          back: "Volver a Eventos",
          visitEvent: "Visitar evento",
        },
        details: {
          lineup: { title: "Lineup" },
          location: { title: "Ubicación" },
          promoter: { title: "Promotor" },
          readLess: "Leer menos",
          readMore: "Leer más",
          title: "Acerca de este evento",
        },
        dropdown: {
          filter: { past: "Eventos pasados", upcoming: "Próximos eventos" },
        },
        emptyState: {
          subtitle:
            "Cambia el filtro de búsqueda para obtener otros resultados.",
          title: "No hay eventos para mostrar",
        },
      },
      gallery: { button: { download: "Descargar" } },
      networks: { title: "Redes sociales" },
      overview: {
        bio: { readMore: "Leer más", title: "Biografía" },
        eventList: {
          title: { future: "Próximos eventos", past: "Eventos pasados" },
        },
        eventSlider: { seeMore: "Ver todos", title: "Eventos destacados" },
        gallery: { seeMore: "Ver más", title: "Galería" },
        onlinePresence: {
          exploreAll: "Ver más",
          subtitle: "Sígueme",
          title: "Presencia en línea",
        },
        press: {
          button: {
            readMore: "Leer más",
            viewAll: "Ver todos los artículos",
          },
          details: {
            button: {
              return: "Todos los artículos de prensa",
              visit: "Visitar artículo",
            },
          },
          title: "Artículos de prensa",
        },
        techRider: {
          information:
            "La imagen es solo de referencia y puede no ser totalmente representativa.",
          seeMore: "Explorar detalles",
          title: "Rider técnico",
        },
        tracks: {
          seeMore: "Ver más",
          table: {
            album: "Álbum",
            duration: "Duración",
            label: "Sello",
            plays: "Reproducciones",
            releaseDate: "Fecha de lanzamiento",
            title: "Título",
          },
          title: "Top tracks",
        },
        videos: { seeMore: "Ver más", title: "Top videos" },
      },
      player: {
        listenOn: {
          desktop: "Disponible en",
          mobile: "Sigue escuchando en",
        },
      },
      tab: { events: "Eventos", gallery: "Galería", overview: "Resumen" },
    },
    privacy: {
      button: "Volver a la página de inicio",
      changes: {
        description:
          "Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Le notificaremos cualquier cambio publicando la nueva política en nuestro sitio web.",
        titleBold: "6. Cambios en la Política de Privacidad:",
      },
      collection: {
        description:
          "Recopilamos información personal que usted nos proporciona directamente, como su nombre, dirección de correo electrónico y número de teléfono, cuando se registra en nuestro sitio web, realiza una compra o se pone en contacto con nosotros.",
        titleBold: "1. Recopilación de Información:",
      },
      contact: {
        description:
          "Si tiene alguna pregunta sobre esta política de privacidad, puede contactarnos en privacidad@mavelpoint.com",
        titleBold: "7. Contacto:",
      },
      protection: {
        description:
          "Implementamos medidas de seguridad adecuadas para proteger su información personal contra el acceso no autorizado, la alteración, divulgación o destrucción.",
        titleBold: "3. Protección de la Información:",
      },
      rights: {
        description:
          "Usted tiene derecho a acceder, rectificar y suprimir sus datos personales. También podrá ejercer otros derechos garantizados por la normativa europea y española. Para más información, puede ponerse en contacto con nosotros en privacidad@mavelpoint.com",
        titleBold: "5. Derechos del Usuario:",
      },
      sharing: {
        bulletPoint1: "Con su consentimiento.",
        bulletPoint2: "Para cumplir con obligaciones legales.",
        bulletPoint3:
          "Para proteger nuestros derechos y la seguridad de nuestros usuarios.",
        description:
          "No compartimos su información personal con terceros, excepto en las siguientes circunstancias:",
        titleBold: "4. Compartir Información:",
      },
      subtitle:
        "En MavelPoint nos comprometemos a proteger la privacidad de nuestros usuarios. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos su información personal.",
      title: "Política de Privacidad",
      use: {
        bulletPoint1: "Proporcionar y mejorar nuestros servicios.",
        bulletPoint2: "Procesar sus transacciones y enviarle confirmaciones.",
        bulletPoint3:
          "Responder a sus consultas y ofrecerle soporte al cliente.",
        bulletPoint4:
          "Enviarle comunicaciones promocionales y de marketing, si ha dado su consentimiento para ello.",
        description: "Utilizamos su información personal para:",
        titleBold: "2. Uso de la Información:",
      },
    },
    cookie: {
      changes: {
        description:
          "Nos reservamos el derecho de actualizar esta política de cookies en cualquier momento. Te notificaremos cualquier cambio publicando la nueva política en nuestro sitio web.",
        titleBold: "5. Cambios en la Política de Cookies:",
      },
      contact: {
        description:
          "Si tienes alguna pregunta sobre esta política de cookies, puedes ponerte en contacto con nosotros en privacidad@mavelpoint.com",
        titleBold: "6. Contacto:",
      },
      how: {
        bulletPoint1: "Recordar tus preferencias y configuraciones.",
        bulletPoint2:
          "Mejorar la funcionalidad y el rendimiento de nuestro sitio web.",
        bulletPoint3:
          "Analizar el tráfico y el comportamiento de los usuarios en nuestro sitio.",
        bulletPoint4: "Proporcionar contenido y publicidad personalizados.",
        description: "Utilizamos cookies para:",
        titleBold: "2. ¿Cómo utilizamos las cookies?",
      },
      managing: {
        description:
          "Puedes gestionar las cookies a través de la configuración de tu navegador. La mayoría de los navegadores te permiten rechazar o aceptar cookies, así como eliminar las cookies ya almacenadas en tu dispositivo. Ten en cuenta que si decides bloquear o eliminar cookies, es posible que algunas partes de nuestro sitio web no funcionen correctamente.",
        titleBold: "4. Gestión de cookies:",
      },
      subtitle:
        "En MavelPoint utilizamos cookies para mejorar la experiencia de nuestros usuarios en nuestro sitio web. A continuación, te explicamos qué son las cookies, cómo las utilizamos y cómo puedes gestionarlas.",
      title: "Política de Cookies",
      types: {
        bulletPoint1:
          "Cookies esenciales: Estas cookies son necesarias para el funcionamiento del sitio web y no se pueden desactivar en nuestros sistemas. Se suelen configurar en respuesta a acciones realizadas por ti, como configurar tus preferencias de privacidad, iniciar sesión o completar formularios.",
        bulletPoint2:
          "Cookies de rendimiento: Estas cookies nos permiten contar las visitas y fuentes de tráfico para poder medir y mejorar el rendimiento de nuestro sitio. Nos ayudan a saber qué páginas son las más y las menos populares y a ver cómo se mueven los visitantes por el sitio.",
        bulletPoint3:
          "Cookies de funcionalidad: Estas cookies permiten que el sitio web proporcione una funcionalidad y personalización mejoradas. Pueden ser establecidas por nosotros o por terceros cuyos servicios hemos añadido a nuestras páginas.",
        bulletPoint4:
          "Cookies de publicidad: Estas cookies pueden ser establecidas a través de nuestro sitio por nuestros socios publicitarios. Pueden ser utilizadas por esas empresas para crear un perfil de tus intereses y mostrarte anuncios relevantes en otros sitios.",
        titleBold: "3. Tipos de cookies que utilizamos:",
      },
      what: {
        description:
          "Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Estos archivos permiten que el sitio web recuerde tus acciones y preferencias (como el inicio de sesión, el idioma, el tamaño de la fuente y otras preferencias de visualización) durante un período de tiempo, para que no tengas que volver a configurarlas cada vez que regreses al sitio o navegues de una página a otra.",
        titleBold: "1. ¿Qué son las cookies?",
      },
    },
    home: {
      banner: {
        dreambeach: {
          description:
            "Participa en el concurso MavelPoint UPNEXT y consigue la oportunidad de tocar en nuestro escenario 360 este verano en Almería.",
          title: "¿Quieres pinchar en Dreambeach 2025?",
        },
      },
      benefitsSection: {
        firstCard: {
          description:
            "Vincula tus redes sociales, sube fotos, configura tu rider técnico, promociona tus eventos y escribe tu biografía. Nosotros nos encargamos del diseño.",
          listOne: "Fácil de crear",
          listThree: "Todo en un solo lugar",
          listTwo: "Siempre actualizado",
          subtitle: "Un perfil destacado en solo unos simples pasos",
          title: "Crear tu press kit",
        },
        secondCard: {
          description:
            "Promotores, agencias y otros profesionales de la industria podrán encontrarte, interesarse en tu contenido y ofrecerte oportunidades profesionales.",
          listOne: "Amplía tu red",
          listThree: "Incrementa tus requests",
          listTwo: "Déjate descubrir",
          subtitle: "Llega sin esfuerzo a quienes pueden impulsar tu carrera",
          title: "Aumentar tu visibilidad",
        },
        thirdCard: {
          description:
            "Utiliza MavelTree, nuestra herramienta para hacer tu presencia online accesible y aumentar el engagement con un perfil actualizado.",
          listOne: "Automático",
          listThree: "Siempre actualizado",
          listTwo: "Enlace todo en uno",
          subtitle: "Olvídate de actualizar tu enlace manualmente",
          title: "Optimizar tu link in bio",
        },
        titleColor: "plataforma todo en uno",
        titleOne: "Únete a nuestra",
        titleTwo: "para",
      },
      button: { createPressKit: "Crea tu MavelPoint" },
      callToAction: {
        button: "Únete",
        buttonSuccess: "¡Listo!",
        error: {
          "500":
            "No pudimos añadirte a la lista de espera. Por favor, inténtalo de nuevo más tarde.",
          invalidEmail:
            "Correo electrónico inválido. Por favor, verifica el formato (ej.: nombre@ejemplo.com)",
        },
        input: { placeHolder: "Introduce tu email" },
        success:
          "Ya estás en nuestra lista de espera. Pronto nos pondremos en contacto contigo.",
      },
      footer: {
        cookie: "Política de Cookies",
        privacy: "Política de privacidad",
        rights: "© MavelPoint 2025, Todos los derechos reservados.",
        terms: "Términos y condiciones",
      },
      headerSection: {
        description:
          "¿Buscas un espacio para mostrar quién eres como artista? MavelPoint se conecta con tus redes sociales y servicios de streaming para potenciar tu visibilidad.",
        title: "Tu press kit es ahora tu",
        titleColor: "MavelPoint",
      },
      industryConnectionSection: {
        cardBooking: {
          badge: {
            comingSoon: "Próximamente",
            title: "Agencias de booking",
          },
          subtitle:
            "Gestiona fácilmente las fechas de presentaciones, giras y eventos, evitando conflictos y optimizando la disponibilidad de tus artistas.",
          title: "Gestión profesional de roster",
        },
        cardLabels: {
          badge: {
            comingSoon: "Próximamente",
            title: "Sellos discográficos",
          },
          subtitle:
            "Prefiltra tracks, visualiza su progreso y accede a información del artista de forma centralizada.",
          title: "Gestión de tracks optimizada",
        },
        cardPress: {
          badge: { comingSoon: "Próximamente", title: "Medios y prensa" },
          subtitle:
            "Asigna miembros del equipo para la cobertura de cada evento.",
          title: "Cobertura de eventos optimizada",
        },
        cardPromoters: {
          badge: { comingSoon: "Próximamente", title: "Promotores" },
          subtitle:
            "Facilita el envío de requests, descubre nuevos artistas y toma decisiones basadas en datos.",
          title: "Gestión eficiente de eventos",
        },
        iconSpan: "Artista",
        subtitle:
          "Gana visibilidad con los actores clave y atrae oportunidades de crecimiento profesional.",
        title: "con la industria",
        titleColor: "Contacta",
      },
      language: { en: "Inglés", es: "Español" },
      marqueeSection: { manager: "Manager" },
      navBar: { button: "Empezar", buttonSecondary: "Ver demo" },
      role: { dj: "DJ", producer: "Productor" },
      socialMediaSection: {
        listOne: "Actualizado al instante",
        listOneBold: "Auto-sincronización:",
        listThree: "Comparte tus posts",
        listThreeBold: "Aumenta la interacción:",
        listTwo: "Enlaza tus plataformas",
        listTwoBold: "Impulsa tus ventas:",
        subtitle:
          "Tu perfil estará siempre actualizado automáticamente, con tus posts, videos y tracks.",
        title: "tus redes sociales",
        titleColor: "Conecta",
      },
    },
  },
} as const;
